import * as React from 'react'
import {TableCell, TableHead, TableRow, TableSortLabel} from '@mui/material'
import {styled} from '@mui/material/styles'

const StyledTableCell = styled(TableCell)(({theme}) => ({}))

export default function TableHeadBasic(props: any) {
  const {order, orderBy, onRequestSort, headCells} = props

  const createSortHandler = (property: any) => (event: any) => {
    onRequestSort(event, property)
  }

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell: any) => (
          <StyledTableCell
            key={headCell.id}
            align={headCell.alignHead ? headCell.alignHead : props.align ? props.align : 'center'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
            style={{}}
          >
            {headCell?.sort ? (
              <TableSortLabel
                sx={{width: headCell.width}}
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : 'asc'}
                onClick={headCell.sort ? createSortHandler(headCell.id) : undefined}
              >
                {headCell.label}
              </TableSortLabel>
            ) : (
              <>{headCell.label}</>
            )}
          </StyledTableCell>
        ))}
      </TableRow>
    </TableHead>
  )
}
